import { skipToken } from '@reduxjs/toolkit/dist/query/react';
import Modal from 'antd/lib/modal/Modal';
import {
  useAcceptPrivacyPolicyMutation,
  useGetPrivacyPolicyQuery,
} from 'app/api';
import { useGlobalSlice } from 'app/containers/Global/slice';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { logoutUser } from 'utils/helpers';
import { selectIsAuthorized } from '../../slice/selectors';
import PrivacyPolicyText from './PrivacyPolicyText/PrivacyPolicyText';

interface IProps {}

const PrivacyPolicyWrapper: FC<IProps> = ({ children }) => {
  const { t } = useTranslation();

  const isAuthorized = useSelector(selectIsAuthorized);
  const dispatch = useDispatch();
  const globalActions = useGlobalSlice().actions;

  const {
    data: isAcceptedPrivacyPolicy,
    isFetching,
  } = useGetPrivacyPolicyQuery(isAuthorized ? undefined : skipToken);
  const [acceptPrivacyPolicy] = useAcceptPrivacyPolicyMutation();

  const onAcceptPrivacyPolicy = async () => {
    try {
      await acceptPrivacyPolicy().unwrap();
    } catch (error) {
      dispatch(globalActions.handleError(error));
    }
  };

  const onCancel = () => {
    logoutUser();
  };

  if (
    !isAuthorized ||
    isFetching ||
    (isAuthorized && isAcceptedPrivacyPolicy)
  ) {
    return <>{children}</>;
  }

  return (
    <>
      <>{children}</>
      <Modal
        title={t('PrivacyPolicy.Title', 'Privacy Policy')}
        visible={true}
        onOk={onAcceptPrivacyPolicy}
        okText={t('PrivacyPolicy.Accept', 'Accept')}
        onCancel={onCancel}
        cancelText={t('PrivacyPolicy.Cancel', 'Cancel')}
        closeIcon={null}
        maskClosable={false}
        closable={false}
        width={800}
      >
        <PrivacyPolicyText />
      </Modal>
    </>
  );
};

export default PrivacyPolicyWrapper;
